import { render, staticRenderFns } from "./AppWidget.vue?vue&type=template&id=0a5a1315&scoped=true&"
import script from "./AppWidget.vue?vue&type=script&lang=js&"
export * from "./AppWidget.vue?vue&type=script&lang=js&"
import style0 from "./AppWidget.vue?vue&type=style&index=0&id=0a5a1315&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a1315",
  null
  
)

export default component.exports